import { useParams } from "react-router-dom";
import { CloudFrameStack } from "@cloudframe/stack";
import Authorization from "../components/auth/authorization";
import { UserPermission } from "../constants/permissions.constants";
import ContinuumMachineActivationHistory from "../components/continuum-scanner-license/continuum-machine-activation-history";

const ContinuumMachineActivationHistoryPage = () => {
  const { licenseId } = useParams<{ licenseId: string }>();

  if (!licenseId) return null;

  return (
    <Authorization>
      <section key={UserPermission.P_CONTINUUM_SCANNER_LICENSE}>
        <div style={{ margin: 16, minWidth: 0, maxWidth: "100%" }}>
          <CloudFrameStack>
            <ContinuumMachineActivationHistory licenseId={licenseId} />
          </CloudFrameStack>
        </div>
      </section>
    </Authorization>
  );
};

export default ContinuumMachineActivationHistoryPage;
